import { ServicesFactoryBase, IReceiverService, IContentPreviewService, IContentService } from "./CorBase/ServicesFactoryBase";
import { ContentPreviewService, ReceiverService, ContentService, ReceiverFilter } from "../Services/ContBase/AllConServices";

export { IReceiverService, IContentPreviewService, IContentService};

export abstract class ServicesFactory extends ServicesFactoryBase {
	public static getReceiverService(): IReceiverService {
		return new ReceiverService();
	}

	public static getReceiverFilter(idTenant?: number | null, idTag?: number | null): any | null {
		return new ReceiverFilter(idTenant, false, null, null, null, null, null, idTag);
	}

	public static getContentPreviewService(): IContentPreviewService | null {
		return new ContentPreviewService();
	}

	public static getContentService(): IContentService | null {
		return new ContentService();
	}
}